/* @flow */
import React from 'react';
import Glyph from 'components/Glyph.jsx';

import './styles/HelpIcon.scss';

type Props = {
  tooltipText: string,
};

// Note that this used to work by a TooltipTriggger instead of CSS. That used
// our layer system which avoided clipping in boxes but it also made it so we
// couldn't use HelpIcon in server-rendered pages. Going with a pure CSS
// solution gives us more flexibility and when it's not sufficient a
// TooltipTrigger can be used.
function HelpIcon(props: Props) {
  return (
    <span className="HelpIcon-helpGlyph" data-tooltip-text={props.tooltipText}>
      <Glyph color="eclipse" size="small" name="help" solo />
    </span>
  );
}

export default HelpIcon;



// WEBPACK FOOTER //
// ./src/components/HelpIcon.jsx